import { render, staticRenderFns } from "./AddEditAdminExamSettingsDates.vue?vue&type=template&id=6fc9905d"
import script from "./AddEditAdminExamSettingsDates.vue?vue&type=script&lang=js"
export * from "./AddEditAdminExamSettingsDates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports